// Global marker arrays and shared info window
let searchResultMarkers = [];
let defaultStoreMarkers = [];
let markerCluster = null;
let userLocationMarker = null;
let sharedInfoWindow = null;

function shouldHideStore(store) {
  const name = (store?.name || "").toString();
  const format = (store?.format || "").toString();
  return /\bcfc\b/i.test(name) || /\bcfc\b/i.test(format);
}

////
// 1. Load Google Maps and MarkerClusterer
////
function loadGoogleMapsScript(apiKey) {
  return new Promise((resolve, reject) => {
    if (window.google && window.google.maps) {
      resolve();
      return;
    }

    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`;
    script.async = true;
    script.defer = true;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
}
function loadMarkerClustererScript() {
  return new Promise((resolve, reject) => {
    if (window.markerClusterer) {
      resolve();
      return;
    }

    const script = document.createElement("script");
    script.src = "https://unpkg.com/@googlemaps/markerclusterer/dist/index.min.js";
    script.async = true;
    script.defer = true;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

////
// 2. Init map and load store data
////
window.initStoreLocatorMap = function () {
  
  sharedInfoWindow = new google.maps.InfoWindow();
  const config = window.storeLocatorConfig;
  const STORE_DATA_URL = config.dataUrl;

  const mapEl = document.querySelector(config.mapElementSelector);
  if (!mapEl) return;

  const map = new google.maps.Map(mapEl, {
    center: { lat: 54.5, lng: -3 },
    zoom: 6,
    disableDefaultUI: true,
    zoomControl: true,
  });

  fetch(STORE_DATA_URL)
    .then((res) => res.json())
    .then((storeData) => {
      const visibleStoreData = (storeData || []).filter((store) => !shouldHideStore(store));
      const bounds = new google.maps.LatLngBounds();
      const markers = [];

      visibleStoreData.forEach((store, i) => {
        const position = { lat: store.lat, lng: store.lng };
        const svgIcon = getStoreIcon();
        const marker = new google.maps.Marker({ position, title: store.name, icon: svgIcon, map, zIndex: 2, });
        const infoWindow = new google.maps.InfoWindow();
        marker.addListener("click", () => {
          infoWindow.setContent(createInfoWindowContent(store));
          infoWindow.open(map, marker);
        });
        marker.storeIndex = i;
        markers.push(marker);
        defaultStoreMarkers.push(marker);
        bounds.extend(position);
      });

      markerCluster = new markerClusterer.MarkerClusterer({
        map,
        markers,
        renderer: {
          render: ({ count, position }) => {
            let fill = count > 99 ? "#b09043" : count > 9 ? "#0b1a36" : "#8299bd";
            return new google.maps.Marker({
              position,
              icon: {
                url: getClusterIconUrl(count, fill),
                scaledSize: new google.maps.Size(40, 40),
                anchor: new google.maps.Point(20, 20),
              },
            });
          },
        },
      });

      if (markers.length) {
        map.fitBounds(bounds);
      }

      setupSearchHandlers(map, visibleStoreData, config);
      autoSearchByGeolocation(map, visibleStoreData, config);
    });
};


// Search handler
function setupSearchHandlers(map, storeData, config) {
  const input = document.querySelector(config.inputSelector);
  const searchIcon = document.querySelector(".pd-icon-search");
  const clearIcon = document.querySelector(".pd-icon-clear");
  const errorMessage = document.querySelector(".pd-search-error");
  const fallbackMessage = document.querySelector("#fallback-message");

  if (!input || !searchIcon || !clearIcon || !errorMessage) return;

  const showError = (text) => {
    errorMessage.textContent = text;
    errorMessage.classList.remove("hide");
  };
  const hideError = () => {
    errorMessage.textContent = "";
    errorMessage.classList.add("hide");
  };

  const runSearch = () => {
    const value = input.value.trim();
    hideError();
  //   if (fallbackMessage) fallbackMessage.classList.add("hide");

    if (!value.length) {
      showError("Please enter a location or postcode.");
      return;
    }

    const ukPostcodeRegex = /^[A-Z]{1,2}[0-9][0-9A-Z]?\\s?[0-9][A-Z]{2}$/i;

    if (value.length < 4 && !ukPostcodeRegex.test(value)) {
      showError("Please enter a valid UK postcode or address.");
      return;
    }

    geocodePostcode(value).then((coords) => {
      if (coords) {
        const { lat, lng } = coords;
        setUserLocationMarker(map, lat, lng);
        displayNearestStores(lat, lng, map, storeData, config);
      } else {
        showError("Location not found.");
      }
    });
  };

  const autocomplete = new google.maps.places.Autocomplete(input, {
    types: ["geocode"],
    componentRestrictions: { country: "uk" },
  });
  autocomplete.addListener("place_changed", () => {
    const place = autocomplete.getPlace();
    if (!place.geometry || !place.geometry.location) {
      showError("Address not found.");
      return;
    }
    const lat = place.geometry.location.lat();
    const lng = place.geometry.location.lng();
    if (fallbackMessage) fallbackMessage.classList.add("hide");
    setUserLocationMarker(map, lat, lng);
    // hideDefaultMarkers();
    displayNearestStores(lat, lng, map, storeData, config);
  });

  searchIcon.addEventListener("click", (e) => {
    e.preventDefault();
    runSearch();
  });
  input.addEventListener("keypress", (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      runSearch();
    }
  });

  clearIcon.addEventListener("click", () => {
    input.value = "";
    hideError();
    clearIcon.classList.add("hide");
    // showDefaultMarkers(map);
    displayDefaultStores(map, storeData, config);
  });

  input.addEventListener("input", () => {
    clearIcon.classList.toggle("hide", !input.value.trim());
  });
}


function geocodePostcode(postcode) {
  return new Promise((resolve) => {
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ address: postcode }, (results, status) => {
      if (status === "OK") {
        const loc = results[0].geometry.location;
        resolve({ lat: loc.lat(), lng: loc.lng() });
      } else {
        resolve(null);
      }
    });
  });
}




// Auto geolocation
function autoSearchByGeolocation(map, storeData, config) {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude: lat, longitude: lng } = position.coords;
        setUserLocationMarker(map, lat, lng);
        displayNearestStores(lat, lng, map, storeData, config);
      },
      () => displayDefaultStores(map, storeData, config),
      { timeout: 10000 }
    );
  } else {
    displayDefaultStores(map, storeData, config);
  }
}


//// Helpers
function displayDefaultStores(map, storeData, config) {
  const fallbackLat = 51.5074; // London
  const fallbackLng = -0.1278;

  if (document.querySelector("#fallback-message")) {
    document.querySelector("#fallback-message").classList.remove("hide");
  }
  setUserLocationMarker(map, fallbackLat, fallbackLng);

  const sortedStores = storeData
    .map(store => ({
      ...store,
      distance: getDistance(fallbackLat, fallbackLng, store.lat, store.lng)
    }))
    .sort((a, b) => a.distance - b.distance);

  // hideDefaultMarkers();
  displayStoreCards(sortedStores.slice(0, 5), map, config);
}


// Markers
function hideDefaultMarkers() {
  defaultStoreMarkers.forEach(marker => marker.setMap(null));
  if (markerCluster) markerCluster.setMap(null);
}
function showDefaultMarkers(map) {
  defaultStoreMarkers.forEach(marker => marker.setMap(map));
  if (markerCluster) markerCluster.setMap(map);
}





// Main
function displayNearestStores(lat, lng, map, storeData, config) {
  const sortedStores = storeData
    .map(store => ({
      ...store,
      distance: getDistance(lat, lng, store.lat, store.lng)
    }))
    .sort((a, b) => a.distance - b.distance);

  const baseStores = sortedStores.slice(0, 5);
  // const tempBounds = new google.maps.LatLngBounds();
  // baseStores.forEach(store => tempBounds.extend({ lat: store.lat, lng: store.lng }));

  // const visibleStores = sortedStores.filter((store, i) => i < 5 || tempBounds.contains({ lat: store.lat, lng: store.lng }));
  displayStoreCards(baseStores, map, config);
}

function getStructuredAddress(store) {
  const parts = [store.address_1, store.address_2, store.town, store.postcode]
    .map((part) => (part || "").toString().trim())
    .filter(Boolean);
  return parts.join(", ");
}

function getDisplayAddress(store) {
  const structured = getStructuredAddress(store);
  if (structured) return structured;

  const corrected = (store.corrected_address || "").toString().trim();
  if (corrected) return corrected;

  return "Address unavailable";
}

function getDirectionsDestination(store) {
  const corrected = (store.corrected_address || "").toString().trim();
  if (corrected) return corrected;

  const structured = getStructuredAddress(store);
  if (structured) return `${store.name}, ${structured}`;

  return store.name;
}

function displayStoreCards(stores, map, config) {
  const container = document.querySelector(config.resultContainerSelector);
  if (!container) return;
  
  container.innerHTML = "";
  searchResultMarkers.forEach(marker => marker.setMap(null));
  searchResultMarkers = [];

  const bounds = new google.maps.LatLngBounds();

  if (!stores.length) {
    container.innerHTML = '<div class="pd-no-results">No stores found near that location.</div>';
    return;
  }

  stores.forEach((store, index) => {
    const number = index + 1;
    const icon = getStoreIconWithNumber(number);
    const addressText = getDisplayAddress(store);
    const directionsDestination = getDirectionsDestination(store);
    const cardTitle = addressText === "Address unavailable" ? store.name : `${store.name}, ${addressText}`;
    
    const marker = new google.maps.Marker({
      position: { lat: store.lat, lng: store.lng },
      map,
      icon,
      title: store.name,
      zIndex: 900
    });

    marker.addListener("click", () => {
      sharedInfoWindow.setContent(createInfoWindowContent(store));
      sharedInfoWindow.open(map, marker);
    });

    searchResultMarkers.push(marker);
    bounds.extend(marker.getPosition());

    const el = document.createElement("div");
    el.className = "pd-location-card";
    el.dataset.index = index;
    el.innerHTML = `
      <div class="pd-location-card__col pd-location-card__col-store-base">
        <span class="pd-location-card__number">${number}</span>
        <div class="pd-location-card__group">
          <div class="pd-location-card__media">
            <img src="${config.tescoLogoUrl}" alt="Tesco">
          </div>
          <address class="pd-location-card__address">${cardTitle}</address>
        </div>
      </div>
      <div class="pd-location-card__col">
        <div class="pd-location-card__button-group">
          <a class="pd-btn" target="_blank" href="https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(directionsDestination)}">Directions</a>
        </div>
      </div>`;
    el.addEventListener("click", () => {
      google.maps.event.trigger(marker, "click");
      map.panTo(marker.getPosition());
    });
    container.appendChild(el);
  });

  map.fitBounds(bounds);
}







////
// X. Setters
////
function setUserLocationMarker(map, lat, lng) {  
  if (userLocationMarker) userLocationMarker.setMap(null);
  
  const icon = getUserLocationIcon();
  
  userLocationMarker = new google.maps.Marker({
    position: { lat, lng },
    map,
    icon,
    title: "Your Location",
    zIndex: 999,
  });
}




////
// X. Getters
////
function getDistance(lat1, lon1, lat2, lon2) {
  const R = 6371;
  const dLat = ((lat2 - lat1) * Math.PI) / 180;
  const dLon = ((lon2 - lon1) * Math.PI) / 180;
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos((lat1 * Math.PI) / 180) *
    Math.cos((lat2 * Math.PI) / 180) *
    Math.sin(dLon / 2) ** 2;
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c;
}
function getClusterIconUrl(count, fill) {
  return `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(`
    <svg xmlns='http://www.w3.org/2000/svg' width='40' height='40'>
      <circle cx='20' cy='20' r='18' fill='${fill}' />
      <text x='20' y='26' text-anchor='middle' font-size='12' font-family='Arial' fill='#fff'>${count}</text>
    </svg>`)} `;
}
function getStoreIcon() {
  return {
    url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(`
      <svg xmlns='http://www.w3.org/2000/svg' width='32' height='48' viewBox='0 0 32 48'>
        <path d='M16 0C7.163 0 0 7.163 0 16c0 11.046 16 32 16 32s16-20.954 16-32C32 7.163 24.837 0 16 0z' fill='#8d2221'/>
        <circle cx='16' cy='16' r='6' fill='white'/>
      </svg>`)} `,
    scaledSize: new google.maps.Size(32, 48),
    anchor: new google.maps.Point(16, 48),
  };
}
function getStoreIconWithNumber(number) {
  return {
    url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(`
      <svg xmlns='http://www.w3.org/2000/svg' width='32' height='48' viewBox='0 0 32 48'>
        <path d='M16 0C7.163 0 0 7.163 0 16c0 11.046 16 32 16 32s16-20.954 16-32C32 7.163 24.837 0 16 0z' fill='#8d2221'/>
        <text x='16' y='22' text-anchor='middle' font-size='16' font-family='Arial' fill='white'>${number}</text>
      </svg>`)} `,
    scaledSize: new google.maps.Size(32, 48),
    anchor: new google.maps.Point(16, 48),
  };
}
function getUserLocationIcon() {
  return {
    url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(`
      <svg xmlns='http://www.w3.org/2000/svg' width='32' height='48' viewBox='0 0 32 48'>
        <path d='M16 0C7.163 0 0 7.163 0 16c0 11.046 16 32 16 32s16-20.954 16-32C32 7.163 24.837 0 16 0z' fill='#b09041'/>
        <circle cx='16' cy='16' r='6' fill='white'/>
      </svg>`)} `,
    scaledSize: new google.maps.Size(32, 48),
    anchor: new google.maps.Point(16, 48),
  };
}


/////////////////////
//// Map InfoWindow HTML
function createInfoWindowContent(store) {
  const addressText = getDisplayAddress(store);
  const directionsDestination = getDirectionsDestination(store);

  return `
    <div style="max-width: 240px; font-family: fairplex-wide, serif; font-weight: 500; font-size: 1.2rem; line-height: 1.3; letter-spacing: 0.1rem; text-transform: uppercase; padding-top: 0.8rem; color: #0b1a36;">
      <h2 style="color: #0b1a36; font-size: 1.2rem;">${store.name}</h2>
      <div style="margin-top: 0.5rem; padding-top: 0.5rem; border-top: 1px solid #e3dac5;">
        <address style="font-style: normal; font-weight: 400; letter-spacing: 0;">${addressText}</address>
        <a href="https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(directionsDestination)}" target="_blank" style="display: inline-block; margin-top: 8px; color: #0b1a36; text-decoration: underline;">Get directions</a>
      </div>
    </div>`;
}


  
////////////////////////////////
/////// Start on DOM ready /////
////////////////////////////////
document.addEventListener("DOMContentLoaded", () => {
  const apiKey = "AIzaSyCDli6Qsn11ouf6FNvKxwp4m5YzsfFfFq4";
  loadGoogleMapsScript(apiKey)
    .then(() => loadMarkerClustererScript())
    .then(() => window.initStoreLocatorMap())
    .catch((err) => console.error("Failed to load Google Maps or MarkerClusterer", err));
});


